import React, { Fragment } from 'react';
import { shape, string } from 'prop-types';
import Text from '@clearscore/rainbow.text';
import Button from '@clearscore/rainbow.button';

import style from './reset-password-confirmation.css';

const LOGIN_URL = '/login';

const ResetPasswordConfirmation = ({ language }) => (
    <Fragment>
        <div className={style.confirmationSpacing}>
            <Text.Body1 dataId="password-confirmation-text">{language.confirmationMessage}</Text.Body1>
        </div>
        <div className={style.confirmationSpacing}>
            <Button href={LOGIN_URL} size={Button.sizes.LARGE} dataId="password-confirmation-button">
                {language.confirmationButton}
            </Button>
        </div>
    </Fragment>
);

ResetPasswordConfirmation.propTypes = {
    language: shape({
        confirmationMessage: string.isRequired,
        confirmationButton: string.isRequired,
    }).isRequired,
};

export default ResetPasswordConfirmation;
